import { SelectCover } from '../../../slices/selectCover';

const getSelectCovers = (selectCover: SelectCover) => {
  if (!selectCover) return false;
  const { covers } = selectCover;
  const coverList: string[] = [];
  covers.forEach((cover: string) => coverList.push(cover));

  return { coverType: coverList.join(',') };
};

export default getSelectCovers;
